module.exports = __webpack_public_path__ + "static/img/4197_phase_function_Paper_Points.8cdbc84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4197_phase_function_Paper_Points.png
// module id = hU3p
// module chunks = 0